import { createSelector } from 'reselect';

const settingsSelector = (state) => state.settings;

export const selectSettings = createSelector(
  settingsSelector,
  (state) => state,
);

export const selectRegistrationUrl = createSelector(
  settingsSelector,
  (state) => state.RegistrationUrl,
);

export const selectBuyCashBufferPercentage = createSelector(
  settingsSelector,
  (state) => state.BuyCashBufferPercentage,
);

export const selectMetalStreamMinimumDepositAmount = createSelector(
  settingsSelector,
  (state) => state.MetalStreamMinimumDepositAmount,
);

export const selectNumberOfAllowedAchDepositAccounts = createSelector(
  settingsSelector,
  (state) => state.NumberOfAllowedAchDepositAccounts,
);

export const selectAchDepositLimit = createSelector(
  settingsSelector,
  (state) => state.AchDepositLimit,
);

export const selectCheckDepositLimit = createSelector(
  settingsSelector,
  (state) => state.CheckDepositLimit,
);

export const selectWireWithdrawalFee = createSelector(
  settingsSelector,
  (state) => state.WireWithdrawalFee,
);

export const selectContributionLimitAmount = createSelector(
  settingsSelector,
  (state) => state.RegistrationContributionLimitAmount,
);

export const selectPortalGatewayISOCodesListToIgnoreAreaCode = createSelector(
  settingsSelector,
  (state) => state.PortalGatewayISOCodesListToIgnoreAreaCode,
);

export const selectAlgoliaImageRootUrl = createSelector(
  settingsSelector,
  (state) => state.RootUrl,
);

export const selectIsReCaptchaEnabled = createSelector(
  settingsSelector,
  (state) => state.EnableGoogleReCaptcha,
);

export const selectPortalUrl = createSelector(
  settingsSelector,
  (state) => state.PortalUrl,
);

export const selectIsIRSRequiredFlag = createSelector(
  settingsSelector,
  (state) => state.IsIRSRequired,
);

// flag to determine if we need to run a/b testing for last 4 or full ssn field
// true = run the a/b test which is stil determined by the day of the week
export const selectIsIRSRequired = createSelector(settingsSelector, () => true);
